<template>
  <div class="row">
    <div class="col-md-12 m-b-2 order-actions">
      <order-short-ship :order="order" :products="products" :region="region" :d365Order="d365Order" />
      <order-price-match :order="order" :products="products" :region="region" :d365Order="d365Order" />
    </div>
  </div>
</template>

<script>
  import OrderShortShip from "./OrderShortShip";
  import OrderPriceMatch from "./OrderPriceMatch";

  export default {
    name: 'OrderActions',
    props: {
      order: {
        required: true,
        type: Object,
      },
      products: {
        required: true,
        type: Object,
      },
      region: {
        required: true,
        type: String
      },
      d365Order: {
        required: true,
        type: Object
      }
    },
    components: {
      OrderShortShip,
      OrderPriceMatch
    },
  };
</script>

<style>
  .order-actions>div {
    display: inline-block;
  }
</style>